import { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from '../context/index.js';
import useShowError from './useShowError.js';
import { getToken, isTokenExpired } from '../utils/auth.js';
import { L as LOGIN } from '../paths-ZKN3m62_.js';
import 'notistack';
import '../utils/error.js';
import '../serverErrors-XxD2s73I.js';
import '../utils/logger.js';
import '../utils/logToSlack.js';
import '../utils/logToRelic.js';
import '../index-QrdBfapu.js';
import '../utils/cookies.js';
import 'cookies-next';
import '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-5CMab_Gs.js';
import '../utils/isBot.js';

/**
 * Hook to check if the JWT token has expired and log out the user if it has.
 * Returns a function that checks token expiration and logs out the user if expired.
 * The function returns true if the token was expired and the user was logged out, false otherwise.
 */
const useCheckTokenExpiration = () => {
    const { thunks: { user: { logout: logoutThunk }, }, useDispatch, } = useContext(CoreContext);
    const { replace } = useRouter();
    const dispatch = useDispatch();
    const { t } = useTranslation('', { keyPrefix: '' });
    const showError = useShowError();
    const logout = async () => {
        try {
            dispatch(logoutThunk());
            replace(LOGIN);
        }
        catch (err) {
            console.error('Logout failed:', err);
        }
    };
    const checkTokenExpiration = () => {
        const token = getToken();
        // If no token, consider user is not logged in
        if (!token)
            return false;
        if (!isTokenExpired(token))
            return false;
        showError(t('$common.$validation.sessionExpired'));
        // Logout user
        logout();
        return true;
    };
    return checkTokenExpiration;
};

export { useCheckTokenExpiration as default };
//# sourceMappingURL=useCheckTokenExpiration.js.map
